import React, {useEffect, useState} from 'react';

import styles from './MobileCartProducts.module.css'
import {cn} from "../../../../../utils/cn.ts";
// import {Checkbox} from "../../../../../ui/Filters/components/Checkbox/Checkbox.tsx";
import {AmountCounter} from "../components/AmountCounter/AmountCounter.tsx";
import {Icon} from "../../../../../ui/General/Icon/Icon.tsx";
import {Button} from "../../../../../ui/General/Button/Button.tsx";
import {CartNotAvailableProducts} from "../components/CartNotAvailableProducts/CartNotAvailableProducts.tsx";
import {Order} from "../../../../../types/Order.interface.ts";
import {useToggleSet} from "../../../../../hooks/useSet.tsx";
import {Loader} from "../../../../../ui/Loader/Loader.tsx";
import {CartProduct} from "../../../../../widgets/ProductCard/types/productCard.interface.ts";
import { useNavigate } from 'react-router-dom';
import { cartOfferLoader } from '@/utils/storage/extra/loaders/cart/cartOfferLoader.ts';
import { replaceCartElementRequest } from '@/utils/requests/cart/replaceCartElementRequest.ts';
import { useAppDispatch } from '@/utils/storage/stores/store.ts';

interface Props {
    cartOffer: Order,
    createOrder: (withBonuses: boolean) => Promise<Response>
    setIsOrderPlaced: (isOrderPlaced: boolean) => void,
    isOrderPlaced: boolean,
    addOrLessenProduct: (elementId: number, operation: ProductOperation) => void,
    removeProducts: (ids: number[]) => void,
    isAuth: boolean,
}

interface PropsProduct {
    product: CartProduct,
    addOrLessenProduct: (elementId: number, operation: ProductOperation) => void,
    removeProducts: (ids: number[]) => void,
    toggle: (id: number) => void,
    setShowWarning: (showWarning: boolean) => void,
    checked: (id: number) => boolean,
    cartId: number,
}

type ProductOperation = 'add' | 'remove'

const Product: React.FC<PropsProduct> = ({
                                             product,
                                             addOrLessenProduct,
                                             removeProducts,
                                             cartId,
                                             // toggle,
                                             setShowWarning,
                                             checked,
                                         }) => {
    const dispatch = useAppDispatch();
    const {
        id,
        name,
        brand,
        article,
        price,
        amount,
        stock,
        isAvailable
    } = product;

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [failedReplace, setFailedReplace] = useState<boolean>(false);

    const replaceItem = (id: number) => {
        setIsLoading(true);
        replaceCartElementRequest(id)
        .then(() => {
            dispatch(cartOfferLoader({cartId, isMini: false, all: true}));
        })
        .catch(error => {
            console.error(error);
            setFailedReplace(true);
            setShowWarning(true);
        })
        .finally(() => setIsLoading(false));
        // replaceCartElement(cartId, id)
        //     .catch(() => {
        //         setShowWarning(true);
        //         setFailedReplace(true);
        //     })
        //     .then(() => setIsLoading(false))
    }

    return (
        <li key={id} className={cn(
            styles.product,
            checked(id) && styles.productChosen,
            !isAvailable && styles.productNotAvailable
        )}>
            {/*<Checkbox*/}
            {/*    viewType='check'*/}
            {/*    disabled={!isAvailable}*/}
            {/*    className={cn(styles.checkbox)}*/}
            {/*    checked={checked(id)}*/}
            {/*    onChange={() => {*/}
            {/*        toggle(id)*/}
            {/*    }}*/}
            {/*/>*/}
            <div className={styles.name}>{name}</div>
            <div
                className={styles.iconCloseWrapper}
                onClick={() => {
                    removeProducts([id])
                }}
            >
                <Icon
                    className={styles.close}
                    name='close'
                    width={14}
                    height={14}
                />
            </div>
            <div className={styles.info}>
                <div className={styles.brand}>{brand}</div>
                <div className={styles.productId}>{article}</div>
            </div>
            {isAvailable ? (<>
                    <div className={styles.price}>{price} ₽</div>
                    <div className={styles.counterWrapper}>
                        <AmountCounter
                            price={price}
                            amount={amount}
                            stock={stock}
                            counterTotalCss={styles.counterTotal}
                            add={() => addOrLessenProduct(id, 'add')}
                            remove={() => addOrLessenProduct(id, 'remove')}
                        />
                    </div>
                </>)
                :
                (<>
                    <Button
                        className={cn(styles.btn, styles.btnNewOffers)}
                        type='regular'
                        onClick={() => replaceItem(id)}
                    >
                        {isLoading ? <><Loader /> Производится поиск</> : (failedReplace ? <>Варианты не найдены</> : <>Найти новые предложения</>)}
                    </Button>
                </>)
            }
        </li>
    );
}

export const MobileCartProducts: React.FC<Props> = ({
                                                        addOrLessenProduct,
                                                        removeProducts,
                                                        cartOffer,
                                                        createOrder,
                                                        setIsOrderPlaced,
                                                        isOrderPlaced,
                                                        isAuth,
                                                    }) => {
    const {
        toggle,
        has: checked,
        // items: ids
    } = useToggleSet<number>();
    const navigate = useNavigate();
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [failedNotAuthUser, setFailedNotAuthUser] = useState<boolean>(false);
    let [isLoading, setIsLoading] = useState<boolean>(false);

    const NotAvailableCount = cartOffer.products.filter(({isAvailable}) => !isAvailable).length;

    const totalPrice = () => {
        const delivery = cartOffer.delivery.courierPrice ?? 0;
        const transportCompany = cartOffer.delivery.transportCompanyPrice ?? 0;

        const products = cartOffer.products.reduce((prev, next) => {
            return prev + (next.price * next.amount)
        }, 0)

        return delivery + transportCompany + products;

    };

    // function addAll(): void {
    //     cartOffer.products.forEach(({id, isAvailable}) => {
    //         if (!checked(id) && isAvailable) {
    //             toggle(id)
    //         }
    //     })
    // }

    const totalAmount = cartOffer.products.reduce((prev, next) => {
        return prev + next.amount
    }, 0);

    const receiveCreateOrder = () => {
        if(!isAuth) {
            setFailedNotAuthUser(true);
            return;
        }
        setIsLoading(true);
        if(!isOrderPlaced) setIsOrderPlaced(true);
        else createOrder(false)
        .then(response => response.json())
            .then(result => {
            if(result.hash) {
                navigate(`/m/${result.hash}`);
                if (result.url) location.href = result.url;
            } else {
                if(result.message) {
                    alert(result.message);
                    setIsLoading(false);
                }
            }
            return null;
        });
        ;
    }

    useEffect(() => {
        if(isAuth) setFailedNotAuthUser(false);
    }, [isAuth]);
    return (
        <>
            <div className={styles.notAvailableProducts}>
                <CartNotAvailableProducts productsNotAvailableCount={NotAvailableCount} showWarning={showWarning}/>
            </div>
            <h2 className={styles.title}>Товары в корзине</h2>
            {/*<div className={styles.buttons}>*/}
            {/*    <Button*/}
            {/*        type='text'*/}
            {/*        className={styles.btnChooseAll}*/}
            {/*        onClick={() => addAll()}*/}
            {/*    >*/}
            {/*        Выбрать все*/}
            {/*    </Button>*/}
            {/*    <Button*/}
            {/*        type='text'*/}
            {/*        className={styles.btnDeleteAll}*/}
            {/*        onClick={() => removeProducts(ids)}*/}
            {/*    >*/}
            {/*        Удалить*/}
            {/*    </Button>*/}
            {/*</div>*/}
            <ul className={styles.productList}>
                {cartOffer.products.map((product) => (
                    <Product
                        key={product.id}
                        toggle={toggle}
                        checked={checked}
                        addOrLessenProduct={addOrLessenProduct}
                        removeProducts={removeProducts}
                        cartId={cartOffer.cartId}
                        product={product}
                        setShowWarning={setShowWarning}
                    />
                ))}
            </ul>
            <div className={styles.chosenProducts}>
                <div>
                    Выбрано товаров
                </div>
                <div>{totalAmount} шт</div>
            </div>
            <div className={styles.outline}/>
            <div className={styles.total}>
                <div className={styles.totalTitle}>Итого к оплате:</div>
                <div className={styles.price}>{totalPrice()} ₽</div>
            </div>
            {
                failedNotAuthUser
                    ?
                    <div className={styles.warning}>
                        Для продолжения оформления заказа необходимо войти или зарегистрироваться
                    </div>
                    : null
            }
            <Button
                className={styles.btnOrder}
                type='regular'
                disabled={isLoading}
                id='order-btn'
                onClick={() => receiveCreateOrder()}
            >
                {isLoading ? <><Loader /> Заказ оформляется</> : <>Оформить заказ</>}
            </Button>
        </>
    );
};